import {
  Swiper, SwiperOptions, Pagination, Navigation, Autoplay,
} from 'swiper';

const updateCounter = (swiper) => {
  const counter = swiper.el.closest('.slider').querySelector('.slider__counter-current');
  if (counter) {
    const index = swiper.realIndex + 1;
    counter.innerHTML = index;
  }
};

/**
 * Slider
 * */

Swiper.use([Navigation, Pagination, Autoplay]);

const sliderInit = () => {
  const sliders: NodeListOf<HTMLElement> = document.querySelectorAll('.slider .slider__swiper');

  sliders.forEach((slide: HTMLElement) => {
    const slideWrapper = slide.closest('.slider');

    // Default arguments for each swiper instance
    const args: SwiperOptions = {

      on: {
        slideChange: updateCounter,
      },

      pagination: {
        el: slideWrapper.querySelector('.slider__pagination') as HTMLElement,
        clickable: true,
      },

      navigation: {
        nextEl: slideWrapper.querySelector('.slider__button--next') as HTMLElement,
        prevEl: slideWrapper.querySelector('.slider__button--prev') as HTMLElement,
      },
    };

    // If slider has custom options combine them and create
    // Swiper instance, otherwise create Swiper instance with
    // default options (custom overwrites default)
    const attr = JSON.parse(slide.getAttribute('data-swiper'));

    const swiper = new Swiper(slide, { ...args, ...attr });
    return swiper;
  });
};

export default sliderInit;
